export const CHANGE_SCREEN = "CHANGE_SCREEN";
export const SET_USER_EMAIL = "SET_USER_EMAIL";
export const SET_FACTOR_ID = "SET_FACTOR_ID";
export const SET_SESSION_TOKEN = "SET_SESSION_TOKEN";
